// extracted by css-extract-rspack-plugin
export default {"cls1":"DebugPage-cls1_o8K","cls2":"DebugPage-cls2_BDf DebugPage-cls1_o8K"};